import zod from 'zod';
import { stringToList, stringToBoolean, stringToListOfNumber, zodLimit, zodPage } from './helpers';

export const personTypes = [
    'wanted',
    'missing',
] as const;

export type PersonType = typeof personTypes[number];

export const FacialSchemas = {
    LiveEvents: zod.object({
        cameras: stringToList.optional(),
    }),
    LiveAlerts: zod.object({
        cameras: stringToList.optional(),
    }),
    Search: zod.object({
        onlyWithPerson: stringToBoolean.optional(),
        personId: zod.coerce.number().optional(),
        beginIn: zod.coerce.number().optional(),
        endIn: zod.coerce.number().optional(),
        cameras: stringToList.optional(),
        markers: stringToListOfNumber.optional(),
        confidence: zod.coerce.number().optional(),
        personType: zod.enum(personTypes).optional(),
        personText: zod.string().optional(),
    }),
    Markers: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
    IgnoredPeople: zod.object({
        page: zodPage,
        limit: zodLimit(),
        textFilter: zod.string().optional(),
    }),
    PeopleList: zod.object({
        page: zodPage,
        limit: zodLimit(),
        onlyActive: stringToBoolean.optional(),
        nameOrDocument: zod.string().optional(),
        markers: stringToListOfNumber.optional(),
        personType: zod.enum(personTypes).optional(),
    }),
    PersonForm: zod.object({
        id: zod.coerce.number().optional(),
    }).optional(),
    LiveEventDetail: zod.object({
        eventId: zod.coerce.number(),
    }),
    LiveAlertEventDetail: zod.object({
        eventId: zod.coerce.number(),
    }),
    SearchEventDetail: zod.object({
        eventId: zod.coerce.number(),
    }),
} as const;
